import { AccessType } from "./enums/AccessType";
import { PhoneNumber, Portfolio, PortfolioTabStatus, SignDocumentCount } from "../common/common";
import { PaidSubscription } from "../common/subscription";
import { CustomRoleForUser } from "../common/customRole";
import { PortfolioCompany } from "../stores/PortfolioStore";
import { DateValue } from "../utils/Dates";

export type StarredCompany = {
  organisationNumber: string;
  accessType: string;
};

export type UserSettings = {
  altinnSystemId?: string;
  starredCompanies?: StarredCompany[];
  preferredPortfolioTab?: PortfolioTabStatus;
  apiKey?: ApiKey;
  lastVisitedCompanies?: { [orgNo: string]: DateValue };
};

export type ApiKey = {
  key: string;
  isActive: boolean;
  expiresAt: string;
};

export interface LoggedOnUserInfoDTO {
  user: User;
  userSettings: UserSettings;
  companies: PortfolioCompany[];
  subscriptionStatuses: PaidSubscription[];
  signDocumentCounts: SignDocumentCount[];
  portfolios: Portfolio[];
  userRoles: CustomRoleForUser[];
}

export interface UserCompany {
  organisationNumber: string;
  name: string;
  isCustomer: boolean;
  accessType: AccessType;
  shareholderId?: number;
  onBehalfOfShareholderCompany?: string;
  onBehalfOfOrganisationNumber?: string;
  onBehalfOfShareholderPerson?: string;
}

export interface User {
  userId: number;
  userName: string;
  email?: string;
  firstName?: string;
  middleName?: string;
  lastName: string;
  phoneNumber?: PhoneNumber;
  acceptedTerms: boolean;
  language: string;
  hasPassword: boolean;
  socialSecurityNumber?: string;
  authenticatedCountry?: string;
  isImpersonated?: boolean; // true if the user is impersonated by a superadmin, hidden otherwise
  isEmailVerified: boolean;
  externalId: string;
}

export const formatUserName = (user: User | null): string =>
  [user?.firstName, user?.middleName, user?.lastName].join(" ");
